import { render } from "./Response.vue?vue&type=template&id=e133c23c"
import script from "./Response.vue?vue&type=script&lang=js"
export * from "./Response.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/Vakifbank-Vue-Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__